module.exports = __webpack_public_path__ + "img/tesoreria.e84c34c8.svg";